import React from 'react';

function VideoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      fill="none"
      viewBox="0 0 35 30"
    >
      <path fill="#000" d="M0 0H35V30H0z" />
      <path
        fill="#fff"
        d="M25.08 14.556L12.268 21l.047-12.98 12.767 6.536z"
      />
    </svg>
  );
}

export default VideoIcon;
